const FR = {
    lang: 'fr',
    version: 1,
    updated: '2026-05-10',
    objects: [
        { id: 'fr-brique', name: 'BRIQUE', familiarity: 1 },
        { id: 'fr-trombone', name: 'TROMBONE', familiarity: 1 },
        { id: 'fr-journal', name: 'JOURNAL', familiarity: 1 },
        { id: 'fr-chaussure', name: 'CHAUSSURE', familiarity: 1 },
        { id: 'fr-tasse', name: 'TASSE', familiarity: 1 },
        { id: 'fr-parapluie', name: 'PARAPLUIE', familiarity: 2 },
        { id: 'fr-bouton', name: 'BOUTON', familiarity: 2 },
        { id: 'fr-cuillere', name: 'CUILLÈRE', familiarity: 2 },
        { id: 'fr-ressort', name: 'RESSORT', familiarity: 2 },
        { id: 'fr-elastique', name: 'ÉLASTIQUE', familiarity: 2 },
        { id: 'fr-raquette', name: 'RAQUETTE', familiarity: 3 },
        { id: 'fr-casserole', name: 'CASSEROLE', familiarity: 3 },
        { id: 'fr-cintre', name: 'CINTRE', familiarity: 3 },
        { id: 'fr-bocal', name: 'BOCAL', familiarity: 3 },
        { id: 'fr-craie', name: 'CRAIE', familiarity: 3 },
        { id: 'fr-poulpe', name: 'POULPE EN SILICONE', familiarity: 4 },
        { id: 'fr-statuette', name: 'STATUETTE', familiarity: 4 },
        { id: 'fr-ventouse', name: 'VENTOUSE', familiarity: 4 },
        { id: 'fr-bobine', name: 'BOBINE DE FIL', familiarity: 4 },
        { id: 'fr-aimant', name: 'AIMANT', familiarity: 4 },
        { id: 'fr-kazoo', name: 'KAZOO', familiarity: 5 },
        { id: 'fr-fanion', name: 'FANION', familiarity: 5 },
        { id: 'fr-boussole', name: 'BOUSSOLE', familiarity: 5 },
        { id: 'fr-mappemonde', name: 'MAPPEMONDE', familiarity: 5 },
        { id: 'fr-cordage', name: 'CORDAGE', familiarity: 5 },
    ],
};
const EN = {
    lang: 'en',
    version: 1,
    updated: '2026-05-10',
    objects: [
        { id: 'en-brick', name: 'BRICK', familiarity: 1 },
        { id: 'en-paperclip', name: 'PAPERCLIP', familiarity: 1 },
        { id: 'en-newspaper', name: 'NEWSPAPER', familiarity: 1 },
        { id: 'en-shoe', name: 'SHOE', familiarity: 1 },
        { id: 'en-mug', name: 'MUG', familiarity: 1 },
        { id: 'en-umbrella', name: 'UMBRELLA', familiarity: 2 },
        { id: 'en-button', name: 'BUTTON', familiarity: 2 },
        { id: 'en-spoon', name: 'SPOON', familiarity: 2 },
        { id: 'en-spring', name: 'SPRING', familiarity: 2 },
        { id: 'en-rubberband', name: 'RUBBER BAND', familiarity: 2 },
        { id: 'en-racquet', name: 'RACQUET', familiarity: 3 },
        { id: 'en-saucepan', name: 'SAUCEPAN', familiarity: 3 },
        { id: 'en-hanger', name: 'HANGER', familiarity: 3 },
        { id: 'en-jar', name: 'JAR', familiarity: 3 },
        { id: 'en-chalk', name: 'CHALK', familiarity: 3 },
        { id: 'en-octopus', name: 'SILICONE OCTOPUS', familiarity: 4 },
        { id: 'en-figurine', name: 'FIGURINE', familiarity: 4 },
        { id: 'en-suction', name: 'SUCTION CUP', familiarity: 4 },
        { id: 'en-spool', name: 'THREAD SPOOL', familiarity: 4 },
        { id: 'en-magnet', name: 'MAGNET', familiarity: 4 },
        { id: 'en-kazoo', name: 'KAZOO', familiarity: 5 },
        { id: 'en-pennant', name: 'PENNANT', familiarity: 5 },
        { id: 'en-compass', name: 'COMPASS', familiarity: 5 },
        { id: 'en-globe', name: 'GLOBE', familiarity: 5 },
        { id: 'en-rope', name: 'ROPE', familiarity: 5 },
    ],
};
const BANKS = { fr: FR, en: EN };
export function getBank(lang) {
    return BANKS[lang];
}
/**
 * Sélectionne un objet de la tier de familiarity demandée. Si plusieurs
 * candidats, choix déterministe via `seed` (trialIdx). Si aucun candidat
 * exact, retourne l'objet de tier la plus proche.
 */
export function pickObject(lang, familiarity, seed) {
    const bank = getBank(lang);
    const exact = bank.objects.filter((o) => o.familiarity === familiarity);
    if (exact.length > 0) {
        const idx = ((seed >>> 0) % exact.length) | 0;
        return exact[idx];
    }
    // Fallback : tier la plus proche supérieure ou égale.
    const above = bank.objects
        .filter((o) => o.familiarity >= familiarity)
        .sort((a, b) => a.familiarity - b.familiarity);
    if (above.length > 0) {
        const idx = ((seed >>> 0) % above.length) | 0;
        return above[idx];
    }
    // Dernier recours : tier la plus haute disponible.
    const sorted = [...bank.objects].sort((a, b) => b.familiarity - a.familiarity);
    return sorted[0];
}
/**
 * Normalise un usage saisi : trim, casse-insensible (lowercase), accents
 * conservés (un usage en français a sa typographie). Retire ponctuation
 * et collapse espaces multiples.
 */
export function normalizeUse(input) {
    return input
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s-]/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
}
/**
 * Déduplique une liste d'usages selon leur forme normalisée.
 */
export function dedupeUses(uses) {
    const seen = new Set();
    const out = [];
    for (const u of uses) {
        const k = normalizeUse(u);
        if (k.length === 0)
            continue;
        if (seen.has(k))
            continue;
        seen.add(k);
        out.push(k);
    }
    return out;
}
//# sourceMappingURL=data.js.map